import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    UserGroupIcon,
    ChartBarIcon,
    CogIcon,
    ChartPieIcon,
    CreditCardIcon,
    HomeIcon,
    XMarkIcon,
    GlobeAltIcon
} from '@heroicons/react/24/outline';

const Sidebar = ({ setSidebarOpen }) => {
    const location = useLocation();

    // Navigation items
    const navigation = [
        { name: 'Tableau de bord', href: '/admin', icon: HomeIcon },
        { name: 'Utilisateurs', href: '/admin/users', icon: UserGroupIcon },
        { name: 'Domaines', href: '/admin/domains', icon: GlobeAltIcon },
        { name: 'Quotas', href: '/admin/quotas', icon: ChartPieIcon },
        { name: 'Paiements', href: '/admin/payments', icon: CreditCardIcon },
        { name: 'Statistiques', href: '/admin/stats', icon: ChartBarIcon },
        { name: 'Paramètres', href: '/admin/settings', icon: CogIcon },
    ];

    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center justify-between flex-shrink-0 px-4 py-4">
                <Link to="/admin" className="text-xl font-bold text-white">
                    Admin Panel
                </Link>
                <button
                    onClick={() => setSidebarOpen(false)}
                    className="p-1 text-white rounded-md lg:hidden hover:text-gray-200 focus:outline-none"
                >
                    <XMarkIcon className="w-6 h-6" />
                </button>
            </div>
            <div className="flex flex-col flex-1 px-2 py-4 mt-5 overflow-y-auto">
                <nav className="flex-1 space-y-2">
                    {navigation.map((item) => {
                        const isActive = location.pathname === item.href;
                        return (
                            <Link
                                key={item.name}
                                to={item.href}
                                className={`flex items-center px-4 py-3 text-sm rounded-md ${
                                    isActive
                                        ? 'bg-[#293241] text-white'
                                        : 'text-gray-100 hover:bg-[#2b3f59] hover:text-white'
                                }`}
                            >
                                <item.icon className="w-5 h-5 mr-3" />
                                {item.name}
                            </Link>
                        );
                    })}
                </nav>
                <div className="pt-8 mt-auto border-t border-gray-300">
                    <Link
                        to="/"
                        className="flex items-center px-4 py-3 mt-1 text-sm text-white rounded-md hover:bg-[#2b3f59]"
                    >
                        Retour au site principal
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;